import { Button }          from './Filter.Controls.style'
import { useToggle }       from './Filter.Controls.MultiSelect.Toggle'
import { CheckedIcon, Icon } from 'components/FormComponent/CheckBox'
import { Box, Checkbox } from '@mui/material'

export const MultiSelectCheckbox = ({ Label, PossibleValues, active, setFilters })  => {

  const state = active?.multiSelect?.find(i=>i.property == Label)?.values ?? []
  const toggle = useToggle({ active, setFilters, state, Label })
  
  return (
    <>
    { 
      PossibleValues.map( ({ ValueProperty, Value }, j ) => {

        const isSelected = state?.includes(ValueProperty)
        const isEqualTo1 = state.length === 1
        const onClick    = ()=>{
          // console.log(ValueProperty,isSelected,isEqualTo1, 'hi')
          return toggle(ValueProperty,isSelected,isEqualTo1)
        }
       
        return (
          <Box sx={{ display: 'flex', alignItems: 'center',color:clr?.primary_text,  }}>
            <Checkbox
                checked={isSelected}
                onChange={onClick}
                icon={<Icon size={"16"} />}
                checkedIcon={<CheckedIcon size={"16"} />}
                sx={{ p: 0, pr: '8px', color: "#fff" }}
              />
              <span className='paragraph2-light'>{ Value }</span>
          </Box>
         
          // <Button
          // className='paragraph1-regular'
          //   key        = {j}
          //   isSelected = {isSelected}
          //   onClick    = {onClick}
          //   children   = {Value}
          //   clr        = {clr}
          //   btnType = {Label}
          // />
        )
      })
    }
    </>
  )
}